import React from 'react';
import { Button } from '@fluentui/react-components';
import { QuestionCircle24Regular } from '@fluentui/react-icons';
import { useTourContext } from '../contexts/TourContext';

interface TourButtonProps {

    tourId: string;
    label?: string;
    icon?: React.ReactElement;
    className?: string;
    style?: React.CSSProperties;
}


export const TourButton: React.FC<TourButtonProps> = ({
    tourId,
    label = 'Start Tour',
    icon = <QuestionCircle24Regular />,
    className = '',
    style,
}) => {
    const { startTour } = useTourContext();

    const handleClick = () => {
        startTour(tourId);
    };

    return (
        <Button
            icon={icon}
            onClick={handleClick}
            className={className}
            style={style}
        >
            {label}
        </Button>
    );
};
